module.exports = __webpack_public_path__ + "media/images/area/area_okinawa-regionM400-cb5da80870b91c20c1e545397590d29b.jpg";